export const getFullName = (fn?: string, ln?: string) => {
  return [fn, ln].filter(Boolean).join(' ');
};
